import type { HttpClient } from "../http";
import type {
  BuyerFocusPackageDTO,
  SaveFocusPackageRequest,
  AddFocusPackageItemRequest,
  PricePointDTO,
  BuyerProductRequestDTO,
  CreateBuyerProductRequest,
} from "../types";

export function focusPackagesResource(http: HttpClient) {
  return {
    get: (retailerId: number) =>
      http.get<BuyerFocusPackageDTO>(`/focus-packages/retailer/${retailerId}`),

    save: (retailerId: number, body: SaveFocusPackageRequest) =>
      http.post<BuyerFocusPackageDTO>(`/focus-packages/retailer/${retailerId}`, body),

    addItem: (retailerId: number, body: AddFocusPackageItemRequest) =>
      http.post<BuyerFocusPackageDTO>(`/focus-packages/retailer/${retailerId}/items`, body),

    addItems: (retailerId: number, body: AddFocusPackageItemRequest[]) =>
      http.post<BuyerFocusPackageDTO>(`/focus-packages/retailer/${retailerId}/items/batch`, body),

    updateItem: (
      retailerId: number,
      skuId: number,
      qty: number,
      targetPricePaise?: number | null,
      notes?: string | null,
    ) => {
      const params = new URLSearchParams();
      params.set("qty", String(qty));
      if (targetPricePaise != null) params.set("targetPricePaise", String(targetPricePaise));
      if (notes) params.set("notes", notes);
      return http.put<BuyerFocusPackageDTO>(
        `/focus-packages/retailer/${retailerId}/items/${skuId}?${params.toString()}`,
      );
    },

    removeItem: (retailerId: number, skuId: number) =>
      http.del<BuyerFocusPackageDTO>(`/focus-packages/retailer/${retailerId}/items/${skuId}`),

    getTrends: (skuId: number, days: number = 7) =>
      http.get<PricePointDTO[]>(`/focus-packages/trends/sku/${skuId}?days=${days}`),

    getTemplates: () =>
      http.get<BuyerFocusPackageDTO[]>("/focus-packages/templates"),

    submitRequest: (body: CreateBuyerProductRequest) =>
      http.post<BuyerProductRequestDTO>("/focus-packages/requests", body),

    listRequests: (retailerId?: number) =>
      http.get<BuyerProductRequestDTO[]>(
        retailerId ? `/focus-packages/requests?retailerId=${retailerId}` : "/focus-packages/requests",
      ),
  };
}
